var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngryPack5 = function SvgAngryPack5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#angry-pack5_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#angry-pack5_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.826,
    cy: 195.666,
    rx: 69.139,
    ry: 24.259,
    fill: "#FEAE52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.01 134.398c0 48.159-41.739 87.334-93.399 87.334-51.66 0-93.398-39.175-93.398-87.334 0-48.159 41.739-87.334 93.398-87.334 51.66 0 93.399 39.175 93.399 87.334Z",
    fill: "#FED052",
    stroke: "url(#angry-pack5_svg__c)",
    strokeWidth: 2.426
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.611,
    cy: 134.398,
    rx: 94.611,
    ry: 88.547,
    fill: "url(#angry-pack5_svg__d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.395,
    cy: 77.389,
    rx: 64.287,
    ry: 36.389,
    fill: "url(#angry-pack5_svg__e)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#angry-pack5_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.453,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#angry-pack5_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#angry-pack5_svg__h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.345,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#angry-pack5_svg__i)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m82.076 99.906 33.661 30.856m0-30.856-33.66 30.856",
    stroke: "url(#angry-pack5_svg__j)",
    strokeWidth: 5.61,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.008 99.906 33.661 30.856m0-30.856-33.661 30.856",
    stroke: "url(#angry-pack5_svg__k)",
    strokeWidth: 5.61,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.373,
    cy: 171.436,
    rx: 22.441,
    ry: 29.453,
    fill: "url(#angry-pack5_svg__l)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.373,
    cy: 186.864,
    rx: 16.83,
    ry: 14.025,
    fill: "url(#angry-pack5_svg__m)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.373,
    cy: 186.864,
    rx: 16.83,
    ry: 14.025,
    fill: "url(#angry-pack5_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.112 171.436c0 8.022-2.076 15.231-5.827 20.416-3.74 5.167-9.148 8.336-15.912 8.336-6.765 0-12.172-3.169-15.912-8.336-3.751-5.185-5.827-12.394-5.827-20.416 0-7.993 2.469-15.204 6.429-20.401 3.959-5.197 9.379-8.351 15.31-8.351 5.931 0 11.351 3.154 15.31 8.351 3.96 5.197 6.429 12.408 6.429 20.401Z",
    stroke: "url(#angry-pack5_svg__o)",
    strokeWidth: 1.403
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "angry-pack5_svg__c",
    x1: 40,
    y1: 141.676,
    x2: 229.223,
    y2: 140.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D39D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#FDCA4D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D39D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "angry-pack5_svg__d",
    x1: 134.611,
    y1: 187.768,
    x2: 134.611,
    y2: 222.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2BD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "angry-pack5_svg__j",
    x1: 82.076,
    y1: 115.334,
    x2: 115.737,
    y2: 115.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#261915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "angry-pack5_svg__k",
    x1: 155.008,
    y1: 115.334,
    x2: 188.669,
    y2: 115.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#261915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "angry-pack5_svg__n",
    x1: 135.716,
    y1: 172.553,
    x2: 135.716,
    y2: 198.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FF351F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "angry-pack5_svg__o",
    x1: 135.373,
    y1: 141.983,
    x2: 135.373,
    y2: 200.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFE5A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC527"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "angry-pack5_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 36.389 -64.2872 0 133.395 77.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#FCF2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF2BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "angry-pack5_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 82.453 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "angry-pack5_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 184.345 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "angry-pack5_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 29.4533 -22.4406 0 135.373 171.436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "angry-pack5_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 14.0254 -16.8304 0 135.373 186.864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "angry-pack5_svg__b",
    x: 13.073,
    y: 117.794,
    width: 245.504,
    height: 155.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.807,
    result: "effect1_foregroundBlur_747_98"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "angry-pack5_svg__f",
    x: 34.419,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_98"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "angry-pack5_svg__h",
    x: 136.311,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_98"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "angry-pack5_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h270v270H0z"
  })))));
};
export default SvgAngryPack5;